module.exports = __webpack_public_path__ + "media/images/element/05-a70ac95564fc621471de5aca1f513a8f.svg";